// Room identifiers aren't consistently formatted between mock and real data:
// mock uses "room-floor3-stendahls-se-314" (number is the whole last segment),
// real Unicator data uses "CampusGothenburg-314Aladdin" (number is glued
// directly to the room name, no separator). Pulling the first run of digits
// out of the last "-"-segment handles both.
export const getRoomNumber = ( identifier ) => {
    const lastSegment = identifier.split( '-' ).pop();
    const match = lastSegment.match( /\d+/ );

    return match ? match[ 0 ] : lastSegment;
};

export const getRoomFloor = ( identifier ) => {
    return getRoomNumber( identifier )[ 0 ];
};

// A device isn't tagged with which meeting room it's in directly — but its
// WiFi access point location (e.g. "314") is the same room number that
// appears in a room's identifier. Matching on that number is what lets
// someone's WiFi presence show up as an occupant of a specific room, for
// both mock and real Unicator data.
export const getOccupantIdentitiesInMeetingRooms = ( devices, rooms ) => {
    const roomNumbers = new Set( rooms.map( ( room ) => getRoomNumber( room.identifier ) ) );

    return devices
        .filter( ( device ) => device.locator && roomNumbers.has( device.ap.location ) )
        .map( ( device ) => device.identity );
};
